define('views/content/email_verify',['require','backbone','marionette','jquery-validation','select2','text!templates/content/email_verify.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');
    require('select2');

    var temp = require("text!templates/content/email_verify.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        initialize: function (options) {
            this.code = options.code || 'code';
        },

        ui: function() {
            return {
                message: '.verify_message',
                loadingIcon: '.loading-icon'
            };
        },

        events: {
            
        },

        onRender: function () {
            this.ui.message.text(App.polyglot.t('verify_loading'));
            this.verifyEmail();
        },

        verifyEmail: function () {
            var _this = this;
            var verifyCode = this.code;
            if (verifyCode) {
                $.ajax({
                    url: App.Config.apiBase + 'customers/verify/',
                    method: 'post',
                    data: {
                        code: verifyCode,

                    },
                    success: function (response) {
                        _this.ui.message.text(App.polyglot.t('verify_success'));
                        _this.ui.loadingIcon.addClass('d-none');
                        setTimeout(function () {
                            App.context.redirect('/signin');
                        }, 3 * 1000);
                    },
                    error: function (error) {
                        _this.ui.message.text(App.polyglot.t('verify_error'));
                        _this.ui.loadingIcon.addClass('d-none');
                    },
                    
                });
            }
        }

    });
});
